var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormCoreComponent } from '../form-core';
var StaffFormComponent = /** @class */ (function (_super) {
    __extends(StaffFormComponent, _super);
    function StaffFormComponent() {
        var _this = _super.call(this) || this;
        _this.role = new FormGroup({
            enabled: new FormControl('', Validators.required),
            role: new FormControl('', Validators.required)
        });
        _this.form = new FormGroup({
            profileImage: new FormControl('', Validators.required),
            firstName: new FormControl('', Validators.required),
            lastName: new FormControl('', Validators.required)
        });
        // Can only modify role
        _this.form.disable();
        return _this;
    }
    Object.defineProperty(StaffFormComponent.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        set: function (val) {
            this._disabled = val;
            if (this._disabled) {
                this.role.disable();
            }
            else {
                this.role.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StaffFormComponent.prototype, "staff", {
        set: function (value) {
            if (value) {
                this.form.patchValue(value, { emitEvent: true, onlySelf: true });
                this.form.disable();
                var permission = void 0;
                try {
                    permission = value.permissions.pop();
                }
                catch (ex) {
                    // do nothing
                }
                if (permission) {
                    this.role.patchValue(permission, { emitEvent: true, onlySelf: true });
                }
            }
            else {
                this.form.patchValue({}, { emitEvent: true, onlySelf: true });
                this.form.disable();
                this.role.patchValue({}, { emitEvent: true, onlySelf: true });
            }
        },
        enumerable: true,
        configurable: true
    });
    StaffFormComponent.prototype.onSubmit = function () {
        this.submitted.emit(this.role.value);
    };
    return StaffFormComponent;
}(FormCoreComponent));
export { StaffFormComponent };
